import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router";
import { Button } from "reactstrap";
import { toast } from "react-toastify";
import Breadcrumb from "../../../components/common/breadcrumb";
import { getCourseById, updateCourse } from "../../../services/labServices";
import CourseMacroData from "../../../components/course/courseMacroData";
import Categories from "../../../components/course/courseCategories";
import SaveCoursePopUp from "../../../components/course/saveCoursePopUp";
import CourseUnitsTree from "../../../components/course/courseUnitsTree";

const PreviewCourse = ({ history }) => {
  const { id } = useParams();
  const [currentCourse, setCurrentCourse] = useState({});
  const [popUpSave, setPopUpSave] = useState(false);

  useEffect(async () => {
    if (id) {
      const res = await getCourseById(id);
      const course = res.result.rows[0];
      setCurrentCourse(course);
    }
  }, [id]);

  const handleBackButton = () => {
    history.goBack();
  };

  const handleSaveCourse = async () => {
    const res = await getCourseById(id);
    const course = res.result.rows[0];
    const currentUnits =
      course &&
      course.labUnit &&
      course.labUnit.map((unit) => {
        return unit.labComponent.length > 0;
      });

    const quiz = course && course.labUnit && course.labUnit.filter((unit) => unit.labComponent.find((component) => component.type === "Quiz"));
    const quizComponents = quiz.map((unit) => unit.labComponent.filter((component) => component.type === "Quiz")).flat();
    const questions = quizComponents.map((component) => component.labQuiz.labQuizQuestion.length);
    const allQuizHaveQuestions = questions && questions.every((question) => question > 0);
    const allUnitsHaveComponents = currentUnits && currentUnits.every((unit) => unit);

    if (!allUnitsHaveComponents || !course.level || !course.category || !course.audience || !course.enrollment_requirement || !allQuizHaveQuestions) {
      setPopUpSave(!popUpSave);
      return;
    }
    if (course.status === "Draft") {
      await updateCourse(id, { status: "Inactive" });
    }

    toast.success("Curso guardado exitosamente");
    history.push("/courses");
  };

  const handleSaveDraft = () => {
    history.push(`/courses`);
    updateCourse(id, { status: "Draft" });
    toast.warning("El curso guardado en Draft permanecera en estado deshabilitado");
  };

  return (
    <>
      <Helmet>
        <title>PIN - Back Office Lab</title>
      </Helmet>
      <Breadcrumb title="Nuevo curso" parent="Back Office lab" backButton onBackButton={handleBackButton} />

      {popUpSave && <SaveCoursePopUp isOpen={popUpSave} toggle={() => setPopUpSave(!popUpSave)} course={currentCourse} history={history} />}
      <div className="container-fluid">
        <CourseMacroData course={currentCourse} preview />
      </div>
      <div className="container-fluid" style={{ position: "relative", zIndex: "10" }}>
        <Categories course={currentCourse} preview />
      </div>
      <div className="container-fluid" style={{ position: "relative", zIndex: "0", transition: "none !important" }}>
        <CourseUnitsTree course={currentCourse} />
      </div>

      <div className="container-fluid mb-3">
        <div className="row">
          <div className="col-12 d-flex justify-content-end" style={{ padding: "0 30px" }}>
            <button className="btn mr-2" type="button" onClick={handleSaveDraft}>
              Draft
            </button>
            <Button className="btn-success" type="button" onClick={handleSaveCourse}>
              Guardar curso
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(PreviewCourse);
